import { render, staticRenderFns } from "./QuestionConfigMediaVideo.vue?vue&type=template&id=133e79d2&scoped=true"
import script from "./QuestionConfigMediaVideo.vue?vue&type=script&lang=js"
export * from "./QuestionConfigMediaVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e79d2",
  null
  
)

export default component.exports